import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlayPointList from "../Components/PlayPointList";
import moment from "moment";
import API from '../Services/ManagerCard'
import LocationList from "./Location";

import EmployeeList from '../Components/Employee';

const MangerCardList = () => {
    const [error, setError] = useState({});
    const perPage = 10
    const [currentPage, setCurrentPage] = useState(1);
    const [id, setId] = useState([])
    const [createdDate, setCreatedDate] = useState("");
    const [status, setStatus] = useState("");
    const [managerList, setManagerList] = useState([])
    const [locationId, setLocationId] = useState("");   
     const [employeeId, setEmployeeId] = useState("");

    const inputRef = useRef(null);
    const [cardNo, setCardNo] = useState("");
    const [scanFirst, setScanFirst] = useState("");
    const [employeeName, setEmployeeName] = useState("")
    const [userInfo, setUserInfo] = useState("");

    useEffect(() => {
        getManagerList()
    }, [currentPage]);


    useEffect(() => {
        inputRef.current?.focus();
    }, []);



    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "locationId":
                setLocationId(value);
                break;
            case "employeeId":
                setEmployeeId(value);
                break;
            case "cardNo":
                setCardNo(value);
                break;
            default:
                break;
        }
    };

    const getManagerList = async () => {
        try {
            const response = await API.getManagerCard();
           // console.log("response data....", response?.data?.result)
            setManagerList(response?.data?.result || [])
            // setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const changeStatus = async (id, currentStatus) => {
       // console.log("status........", id, currentStatus)
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeStatusManager(id, updatedStatus);
            if (response.status === 200) {
                setManagerList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Manager Card ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                // getMemberShipList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };


    const handleGetData = async (Id) => {
      //  console.log('id',Id);
        try {
            const response = await API.getManagerCard({ id: Id });
            const fetchedData = response?.data?.result[0];
          //  console.log("fetchdata...", fetchedData)
            if (fetchedData) {
                setId(fetchedData.id);
                setCardNo(fetchedData?.card_no)
                setEmployeeName(fetchedData?.Employee)
                setStatus(fetchedData?.is_active)
                setCreatedDate(fetchedData?.createdAt)
                // setLocationId(fetchedData?.)
                //setDesignationId(fetchedData?.emp_id)
                setEmployeeId(fetchedData?.emp_id)

            } else {
                toast.error("Failed to fetch Manager Card details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const handleCardNo = (e) => {
        const value = e.target.value;
        const numericOnly = value.replace(/\D/g, '');
        setCardNo(numericOnly.slice(0, 11));
    };

    const updateManagerCardData = async () => {
        try {
            const payload = {
                emp_id: parseInt(employeeId),
                card_no: cardNo,
            };
            const response = await API.updateManagerCard(id, payload);
           // console.log('f', response.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getManagerList()
                setCardNo("");
                setScanFirst(false);
                setUserInfo("Assigned");
                inputRef.current?.focus();
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Manager Card. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating designation:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }


    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Manager Card List</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Card No</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {managerList.map((item, index) => (
                                        // console.log("item", item),
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activated" : "Activate"}
                                                                    </button>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.Employee?.first_name} {item.Employee?.last_name}</td>
                                            <td>{item.card_no}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog  modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update SkyCoins</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <LocationList
                                                selectedLocation={locationId}
                                                setSelectedLocation={setLocationId}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                             <EmployeeList
                                        selectedEmployee={employeeId}
                                        setSelectedEmployee={setEmployeeId}
                                        label="Manager" />
                                            {/* <ManagerDesignation
                                                selectedDesignation={designationId}
                                                setSelectedDesignation={setDesignationId}
                                                label="Manager"
                                            /> */}
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="cardScan">
                                                    Scan Card <span style={{ color: "red" }}>*</span>
                                                </label>
                                                {/* {!userInfo && ( */}
                                                <input
                                                    id="cardScan"
                                                    type="text"
                                                    placeholder="Scan Card"
                                                    value={cardNo}
                                                    ref={inputRef}
                                                    // disabled={userInfo}
                                                    className={`form-control ${scanFirst && !cardNo ? "border-danger" : ""}`}
                                                    onChange={handleCardNo}
                                                />
                                                {/* )} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary"
                                    onClick={updateManagerCardData}
                                >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Manager Details</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee Name</th>
                                                            <th>Card No</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{employeeName?.first_name} {employeeName?.last_name}</td>
                                                            <td>{cardNo}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Created Date</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </div>

    );
};

export default MangerCardList;